/* eslint-disable consistent-return */
import {
  Avatar,
  Button,
  Divider,
  Tab,
  Tabs,
} from '@material-ui/core';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Room } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import { useState } from 'react';
import CreateAnnonce from 'pages/Business/AnnoncesCandidats/components/CreateAnnonce';
import Modal from 'components/Modal';
import Annonces from 'pages/Business/AnnoncesCandidats/components/Annonces';
import Candidats from 'pages/Business/AnnoncesCandidats/components/Candidats';
import { useEffect } from 'react';

const OfferModalSideBar = ({ info, profileImage }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [openCreateAnnonce, setOpenCreateAnnonce] = useState(false);
  const [toRefetch, setToRefetch] = useState(false);
  const [stepModal, setStepModal] = useState(0);


  const [annonceLength, setAnnonceLength] = useState(0);
  const [candidatLength, setCandidatLength] = useState(0);

  const handleAnnonceLength = (length) => {
    setAnnonceLength(length);
  };

  const handleCandidatLength = (length) => {
    setCandidatLength(length);
  };

  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [variant, setVariant] = useState(
    window.innerWidth < 768 ? 'fullWidth' : 'standard'
  );

  useEffect(() => {
    const handleResize = () => {
      setVariant(window.innerWidth < 768 ? 'fullWidth' : 'standard');
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={classes.mainContainer}>
      <div className={classes.infoContainer}>
        <div className={classes.avatarContainer}>
          {profileImage ? (
            <Avatar className={classes.avatar} src={profileImage} />
          ) : (
            <Avatar className={classes.avatar}>
              {info.name?.substr(0, 1)}
            </Avatar>
          )}
          <div className={classes.nameContainer}>
            <p className={global.title} style={{ margin: 0 }}>
              {info.name}
            </p>
            <div className={classes.adresseContainer}>
              <Room />
              <p style={{ margin: 0 }}>{`${info.address.cityCode} ${info.address.city}`}</p>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            disableElevation
            className={css({
              backgroundColor: '#C0D9FF',
              borderColor: '#0060F9',
              color: '#0060F9',
              '&:hover': {
                backgroundColor: '#C0D9FF',
                borderColor: '#0060F9',
                color: '#0060F9',
              },
            })}
            onClick={() => setOpenCreateAnnonce(true)}
          >
            Ajouter une offre d'emploi
          </Button>
        </div>
      </div>
      <div>
        <TabContext value={value}>
          <TabList
            indicatorColor="undefined"
            onChange={handleChange}
            variant={variant}
          >
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopRightRadius: 5,
                  background: value === '1' ? 'white' : '#F3F7FF',
                  color: value === '1' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '1' ? 600 : 400,
                  minWidth: '12vw',
                }),
              }}
              className={global.mainTitle}
              label={'Emplois'}
              value="1"
            />
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopRightRadius: 5,
                  background: value === '2' ? 'white' : '#F3F7FF',
                  color: value === '2' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '2' ? 600 : 400,
                  minWidth: '12vw',
                }),
              }}
              className={global.mainTitle}
              label={`Candidats`}
              value="2"
            />
          </TabList>
          <TabPanel
            className={css({
              padding: '0px',
              background: 'white',
              borderRadius: '0 10px 10px 10px',
              minHeight: !annonceLength && 'calc(100vh - 75px - 93px)',
              // maxHeight: 'calc(100vh - 75px - 93px)',
              '@media screen and (max-width: 1023px)': {
                maxHeight: '100%',
              },
              '@media screen and (max-width: 768px)': {
                height: '100%',
              },
            })}
            value="1"
          >
            <Divider className={classes.divider} />
            <Annonces handleAnnonceLength={handleAnnonceLength} idBusinessExternal={info.id} toRefetch={toRefetch} setToRefetch={setToRefetch} />
          </TabPanel>
          <TabPanel
            className={css({
              padding: '0px',
              background: 'white',
              borderRadius: '0 10px 10px 10px',
              minHeight: !candidatLength && 'calc(100vh - 75px - 93px)',
              // maxHeight: 'calc(100vh - 75px - 93px)',
              '@media screen and (max-width: 1023px)': {
                maxHeight: '100%',
              },
              '@media screen and (max-width: 768px)': {
                height: '100%',
              },
            })}
            value="2"
          >
            <Divider className={classes.divider} />
            <Candidats handleCandidatLength={handleCandidatLength} idBusinessExternal={info.id} />
          </TabPanel>
        </TabContext>
      </div>
      <Modal
        nbStep={5}
        onCancel={() => setOpenCreateAnnonce(false)}
        open={openCreateAnnonce}
        title="Ajouter une offre d'emploi"
        step={stepModal}
      >
        <CreateAnnonce
          onChangeStepModal={setStepModal}
          refetchOffre={() => setToRefetch(true)}
          onClose={() => setOpenCreateAnnonce(false)}
          idBusinessExternal={info.id}
        />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 20,
  },
  infoContainer: {
    display: 'flex',
    marginTop: 20,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  divider: {
    marginLeft: '-30px',
    marginRight: '-30px',
    marginBottom: 20,
  },
  avatarContainer: {
    display: 'flex',
    columnGap: 10,
    alignItems: 'center',
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 10,
  },
  adresseContainer: {
    display: 'flex',
    columnGap: 5,
    color: '#5D75A8',
    alignItems: 'center',
  },
  avatar: {
    height: 80,
    width: 80,
  },
  backdrop: {
    zIndex: spacing(1),
    color: '#fff',
  },
});

export default OfferModalSideBar;
